// extracted by mini-css-extract-plugin
export default {"about-container":"About_about-container__Gb3PQ","about-content":"About_about-content__vRCWj","about-card":"About_about-card__pIGYx"};